module.exports = "/_next/static/images/DefaultImageStore-aa535d70b982ec036e47f49280cf1bd6.webp";